import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import Multiselect from '../CreateModal/components/Multiselect'
import { useAgencyInfo } from 'context/agency'

const EditModal = ({ data, handleRefresh, teamTags }) => {
  const [agency] = useAgencyInfo()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  var team_tags = teamTags?.map((item) => {
    return {
      label: item?.name,
      value: item?.name?.toLowerCase().replace(/\s+/g, '-')
    };
  });
  const preselectedTags = team_tags.filter(tag => data?.tags?.some(t => t.value === tag.value));
const [selectedTags, setSelectedTags] = useState(preselectedTags);

  const AppService = useAppServices()
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px  #000',
    boxShadow: 24,
    p: 4,
  }
  const handlemodal = () => {
    setOpenAddProduct(true)
  }


  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true);
      const roles = JSON.parse(e.target.roles.value);

      const payload = {
        _id: data._id,
        username: e.target.name.value,
        email: e.target.email.value,
        roles: roles?.map(item => item.value),
        tags: e.target.tags ? JSON.parse(e.target.tags.value) : [],
        type: 'super_admin_team',
        agency_id: agency._id,
      }
      const { response } = await AppService.auth.UpdateTeam({
        payload: payload,
      })


      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const permissions = [
      {
        label: 'Agent',
        value: 'agent',
      },
      {
        label: 'Developer',
        value: 'developer',
      },
      {
        label: 'Manager',
        value: 'manager',
      },
      {
        label: 'Support',
        value: 'support',
      },
      {
        label: 'Superadmin',
        value: 'superadmin',
      },
      {
        label: 'Graphics',
        value: 'graphics',
      },
      {
        label: 'Client Handling',
        value: 'client_handling',
      },
      {
        label: 'Social Media',
        value: 'social',
      },
    ]
    const preselectedRoles = permissions.filter((permission) => {
      return data?.roles?.includes(permission.value)
    });
    var handleTagChange = (selected) => {
      setSelectedTags(selected);
    };

    const [selectedRoles, setSelectedRoles] = useState(preselectedRoles);
    const handleRoleChange = (selected) => {
      setSelectedRoles(selected); // Update the state
      console.log('Selected Roles:', selected); // Debugging/logging
    };
    return (
      <MDModal open={open} onClose={onClose} width={440}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Edit Staff
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" placeholder="Name" name="name" fullWidth defaultValue={data?.username} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Email
              </MDTypography>
              <MDInput label="Email" placeholder="Email" name="email" fullWidth defaultValue={data?.email} />
            </MDBox>

            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Role
              </MDTypography>
              <Multiselect
                data={permissions}
                edit_data={selectedRoles}
                isMulti={true}
                name="roles"
                onChange={handleRoleChange}
              />
            </MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>Tags</MDTypography>
            <Multiselect
              data={team_tags}
              edit_data={selectedTags}
              isMulti={true}
              name="tags"
              onChange={handleTagChange}
            />

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Edit
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="info" variant="contained" onClick={handlemodal}>
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} data={data} />
    </>
  )
}

export default EditModal
